import React from 'react';
import { TEXT_COLORS, BACKGROUND_COLORS } from '../utils/colorConstants';

const BlockColorSubmenu = ({ onTextColor, onBgColor }) => {
  return (
    <div className="block-color-submenu">
      <div className="block-color-section">
        <div className="block-color-label">Text Color</div>
        <div className="block-color-grid">
          {TEXT_COLORS.map((color) => (
            <button
              key={color.key}
              type="button"
              className={`block-color-swatch ${color.key === 'default' ? 'block-color-default' : ''}`}
              style={color.value ? { color: color.value } : {}}
              onClick={() => onTextColor(color.value)}
              title={color.label}
            >
              A
            </button>
          ))}
        </div>
      </div>
      <div className="block-color-section">
        <div className="block-color-label">Background</div>
        <div className="block-color-grid">
          {BACKGROUND_COLORS.map((color) => (
            <button
              key={color.key}
              type="button"
              className={`block-color-swatch ${color.key === 'default' ? 'block-color-clear' : ''}`}
              style={color.value ? { backgroundColor: color.value } : {}}
              onClick={() => onBgColor(color.value)}
              title={color.label}
            >
              {color.key === 'default' ? '✕' : ''}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlockColorSubmenu;
